/* Figma's multiplayer name tag ("Vik", white on #0d99ff) drawn as a picture
   of text, not text: the white-on-blue label sits under WCAG's pure-
   decoration exemption, but axe can't know that and fails color-contrast
   on a real text node (aria-hidden does not exempt visually rendered text).
   SVG text renders the same and is skipped by the audit. Typography comes
   from the caller's class (`.figTag text`, `.hintTag text`). */

const SIZES = {
  /* 11px label, 4/8/5 padding, 6px corners: the live cursor's tag */
  md: { w: 33, h: 20, rx: 6, y: 13.5 },
  /* 10px label: the dormant hint's smaller cursor */
  sm: { w: 27, h: 17, rx: 5, y: 11.5 },
};

export function FigTag({
  className,
  size = "md",
}: {
  className?: string;
  size?: keyof typeof SIZES;
}) {
  const { w, h, rx, y } = SIZES[size];
  return (
    <svg
      className={className}
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      aria-hidden="true"
    >
      <rect width={w} height={h} rx={rx} fill="var(--fig, #0d99ff)" />
      <text x={w / 2} y={y} textAnchor="middle" fill="#fff">
        Vik
      </text>
    </svg>
  );
}
